import _ from 'lodash'

const isChecked = (state) => state.isAuthenticated !== undefined
const isAuthenticated = (state) => _.get(state, 'isAuthenticated')
const profile = (state) => _.get(state, 'data')
const authErrors = (state) => _.get(state, 'errors')
const isLoading = (state) => _.get(state, 'loading')

export default {
	isChecked,
	isAuthenticated,
	profile,
	authErrors,
	isLoading
}
